<template lang="pug">
	.match-info
		.match-info-header
			span Spiel-Infos
		.match-info-body
			table
				//- Spielbeginn
				tr(v-if="start")
					th Spielbeginn
					td {{ start | formattedDateTime }}

				//- Spieltag
				tr(v-if="gameDay")
					th Spieltag
					td {{ gameDay }}

				//- Spielort
				tr(v-if="location")
					th Spielort
					td {{ location }}

				//- Schiedsrichter
				tr(v-if="referee")
					th Schiedsrichter
					td(width="100%") {{ referee }}

				//- Besucher
				tr(v-if="visitors")
					th Besucher
					td
						span {{ visitors }}
						span(v-if="isVisitorsEstimate") &nbsp;(Schätzung)
</template>

<script>
export default {
	props: {
		referee: String,
		visitors: Number,
		isVisitorsEstimate: Boolean,
		location: String,
		gameDay: String,
		start: String
	}
}
</script>

<style lang="scss" scoped>
	@import "@/assets/scss/bulma-variables.scss";
	.match-info {
		background: $white;
		.match-info-header {
			display: flex;
			align-items: center;
			padding: 0.5em 1em;
			background: $primary;
			color: $white;
			font-weight: bold;
			font-size: 1.25em;
		}
		table tr {
			padding: 0.25em 1em;
			border-bottom: 1px solid $light;
		}
	}
</style>
